const FALLBACK_DESCRIPTION_EN = 'A curated Zgharta Caza stop. Use the village, category, and map context to place it in your route, then confirm timing locally before you go.';
const FALLBACK_DESCRIPTION_AR = 'محطة مختارة في قضاء زغرتا. استخدم القرية والفئة والخريطة لوضعها في مسارك، وتحقق من الوقت محليا قبل الزيارة.';
const FALLBACK_NOTE_EN = 'Use it as a flexible stop and confirm hours or access locally before you go.';
const FALLBACK_NOTE_AR = 'استخدمها كمحطة مرنة وتحقق من الساعات أو إمكانية الوصول محليا قبل الزيارة.';

const manualPlaceEditorial = [
  ['Horsh Ehden Nature Reserve', 'Ehden', 'محمية حرج إهدن', 'إهدن', ['Quiet morning spot', 'Best after rain']],
  ['Saydet el Hosn (Our Lady of the Fortress)', 'Ehden', 'سيدة الحصن', 'إهدن', ['Golden hour view', 'Walkable from Ehden']],
  ['Mar Mema Church', 'Ehden', 'كنيسة مار ماما', 'إهدن', ['Old stone church', 'Quiet morning spot']],
  ['Cathedral of St. Georges', 'Ehden', 'كاتدرائية مار جرجس', 'إهدن', ['Village center', 'Walkable from town center']],
  ['Saint Moura Church', 'Ehden', 'كنيسة القديسة مورا', 'إهدن', ['Quiet morning spot', 'Walkable from town center']],
  ['Monastery of St. Anthony Qozhaya', 'Aarbet Qozhaya', 'دير مار أنطونيوس قزحيا', 'عربة قزحيا', ['Qadisha valley stop', 'Allow extra driving time']],
  ['Saydet Al Marahem (Our Lady of Mercies)', 'Miziara', 'سيدة المراحم', 'مزيارة', ['Village shrine', 'Quiet morning spot']],
  ['Saint Maria Goretti Shrine', 'Miziara', 'مزار القديسة ماريا غورتي', 'مزيارة', ['Village shrine', 'Short stop']],
  ['Bnachii Lake', 'Bnachii', 'بحيرة بنشعي', 'بنشعي', ['Family walk', 'Best before sunset']],
  ['Youssef Bey Karam Statue', 'Ehden', 'تمثال يوسف بك كرم', 'إهدن', ['Local history marker', 'Walkable from town center']],
  ['Al Midan Square', 'Ehden', 'ساحة الميدان', 'إهدن', ['Village center', 'Good first stop']],
  ['Haouqa-Qadisha Trail', 'Ehden', 'مسار حوقا - قاديشا', 'إهدن', ['Trail route', 'Start early']],
  ["Les Caves d'Éden", 'Ehden', 'كهوف إهدن', 'إهدن', ['Call ahead', 'Local review']],
  ['Kharfashmun Park', 'Zgharta', 'حديقة خرفاشمون', 'زغرتا', ['Family walk', 'Quiet afternoon spot']],
  ['Artisanat Zghorta', 'Zgharta', 'حرفيات زغرتا', 'زغرتا', ['Local craft stop', 'Cash may help']],
  ['Al Ferdaws Restaurant', 'Ehden', 'مطعم الفردوس', 'إهدن', ['Sunday lunch', 'Call ahead']],
  ['Beb el Hawa viewpoint', 'Ehden', 'مطلة باب الهوى', 'إهدن', ['Best at golden hour', 'Windy ridge']],
  ['Mazar Saint Rafqa', 'Basloukit', 'مزار القديسة رفقا', 'بسلوقيط', ['Pilgrimage stop', 'Quiet morning spot']],
  ['Minus Pub', 'Ehden', 'ماينوس بَب', 'إهدن', ['Evening stop', 'Call ahead']],
  ['Massaya Zaman Restaurant', 'Zgharta', 'مطعم مضايا زمان', 'زغرتا', ['Local lunch', 'Call ahead']],
].map(([name, village, nameAr, villageAr, editorialLabels]) => ({
  name,
  village,
  nameAr,
  villageAr,
  description: FALLBACK_DESCRIPTION_EN,
  descriptionAr: FALLBACK_DESCRIPTION_AR,
  editorNote: FALLBACK_NOTE_EN,
  editorNoteAr: FALLBACK_NOTE_AR,
  editorialLabels,
}));

const keyFor = (name, village) => `${String(name || '').trim().toLowerCase()}::${String(village || '').trim().toLowerCase()}`;
const editorialByPlaceKey = new Map(manualPlaceEditorial.map(entry => [keyFor(entry.name, entry.village), entry]));

export function getPlaceEditorialOverride(name, village) {
  return editorialByPlaceKey.get(keyFor(name, village)) || null;
}

export function applyPlaceEditorialOverride(place) {
  const editorial = getPlaceEditorialOverride(place.name, place.village);
  if (!editorial) return place;

  return {
    ...place,
    nameAr: place.nameAr || editorial.nameAr,
    villageAr: place.villageAr || editorial.villageAr,
    description: place.description || editorial.description,
    descriptionAr: place.descriptionAr || editorial.descriptionAr,
    editorNote: place.editorNote || editorial.editorNote,
    editorNoteAr: place.editorNoteAr || editorial.editorNoteAr,
    editorialLabels: place.editorialLabels || editorial.editorialLabels,
  };
}

export { FALLBACK_DESCRIPTION_AR, FALLBACK_DESCRIPTION_EN };
